import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@web-frontend/shared/services/toast/toast.service';
import { PlatformService } from '../platform-disable-content/platform.service';
import { User } from '../../../../types-legacy/lib/packages/clock-absence/absenceEmployee';
import { FileValidationService } from '@web-frontend/shared/services/file-validation/file-validation.service';

@Component({
  selector: 'roma-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class PictureComponent {
  @ViewChild('fileInput')
  fileInput: ElementRef<HTMLInputElement> | undefined;

  @Input()
  src = '';

  @Input()
  @HostBinding('class.is-xs')
  isXs = false;

  @Input()
  @HostBinding('class.is-md')
  isMd = false;

  @Input()
  @HostBinding('class.is-lg')
  isLg = false;

  @Input()
  @HostBinding('class.rounded')
  rounded = true;

  @Input()
  @HostBinding('class.can-click')
  canClick = true;

  @Input()
  @HostBinding('class.is-center')
  center = false;

  @Input()
  avatarSize = 120;

  @Input()
  multiSelect = false;

  @Input()
  isLoading = false;

  @Input()
  showIcon = true;

  @Output()
  selectFiles = new EventEmitter<FileList>();

  @Input()
  user: User;

  previewFile: string | ArrayBuffer = '';

  constructor(
    private changeDetectionRef: ChangeDetectorRef,
    private toastService: ToastService,
    private i18n: TranslateService,
    private platformService: PlatformService,
    private fileValidationService: FileValidationService
  ) {}

  @HostListener('click', ['$event'])
  hostClick(evt: MouseEvent) {
    if (
      !this.platformService.isMobileWebBrowser() &&
      (this.platformService.isWeb() || this.platformService.isAndroid())
    ) {
      if (this.canClick) {
        this.fileInput.nativeElement.click();
      } else {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }
  }

  openInputExternal() {
    this.fileInput.nativeElement.click();
  }

  handleImageFile(files: FileList) {
    if (this.checkIfAbleToUpload(files)) {
      this.previewUrl(files);
      this.selectFiles.next(files);
    }
  }

  private previewUrl(files: FileList) {
    this.isLoading = true;
    if (!this.multiSelect) {
      const file = files.item(0);

      const reader = new FileReader();

      reader.onload = () => {
        this.previewFile = reader.result;
        this.isLoading = false;
        this.draw();
      };

      reader.readAsDataURL(file);
    }
  }

  private draw() {
    this.changeDetectionRef.detectChanges();
  }

  checkIfAbleToUpload(files: FileList): boolean {
    const validationResult = this.fileValidationService.validateFileList(
      files,
      this.fileInput?.nativeElement,
      {
        maxSizeBytes: 2 * 1024 * 1024,
        showErrorMessages: true,
      }
    );

    return validationResult.isValid;
  }
}
